/**
 * 全局音频管理器，避免创建多个 audio 元素
 */
class AudioManager {
  private audio: HTMLAudioElement | null = null;
  private curUrl = '';
  private onEnded?: (() => void) = undefined;

  /**
   * 播放或暂停音频
   * @param url 音频地址
   * @returns 返回播放状态：true - 正在播放，false - 已暂停
   */
  toggle = async (url: string): Promise<boolean> => {
    // 如果是同一个音频，切换播放/暂停
    if (this.curUrl === url && this.audio) {
      if (this.audio.paused) {
        await this.audio.play();
        return true;
      }
      this.audio.pause();
      return false;
    }

    // 停止当前播放
    this.stop();

    // 懒加载：首次使用时才创建 audio 元素
    if (!this.audio) {
      this.audio = new Audio();
      this.audio.preload = 'none';

      // 监听播放完成事件
      this.audio.addEventListener('ended', () => {
        this.curUrl = '';
        this.onEnded?.();
      });
    }

    // 播放新音频
    this.curUrl = url;
    this.audio.src = url;

    try {
      await this.audio.play();
      return true;
    } catch (error) {
      console.error('Audio play failed:', error);
      return false;
    }
  };

  /**
   * 停止播放
   */
  stop = (): void => {
    if (this.audio && !this.audio.paused) {
      this.audio.pause();
    }
  };

  /**
   * 设置播放完成回调
   */
  setOnEnded = (callback?: () => void): void => {
    this.onEnded = callback;
  };

  /**
   * 销毁管理器
   */
  destroy = (): void => {
    if (this.audio) {
      this.audio.pause();
      this.audio.src = '';
      this.audio = null;
    }
    this.curUrl = '';
    this.onEnded = undefined;
  };
}

export const audioManager = new AudioManager();
